import { db } from '@util/firebase';
import {
  collection,
  CollectionReference,
  DocumentReference,
  doc,
  getDoc,
  getDocs,
  orderBy,
  query,
  where,
} from 'firebase/firestore';
import { ProtectionPolicyDocument, PolicyDocument } from './settings.types';

const protectionPlanDocument = doc(db, 'admin/protection-plan') as DocumentReference<ProtectionPolicyDocument>;
const policiesCollection = collection(db, 'policies') as CollectionReference<PolicyDocument>;

export async function getProtectionPolicy(): Promise<string> {
  const docSnap = await getDoc(protectionPlanDocument);
  const data = docSnap.data()?.content;
  return data ?? "";
}

export const getReturnPolicy = async (policyDoc: string): Promise<PolicyDocument | null> => {
  // Reject invalid document ids before querying Firestore.
  if (!policyDoc || policyDoc.length > 100) {
    console.warn("Invalid return policy ID (too long or empty):", policyDoc?.substring(0, 50));
    return null;
  }

  try {
    const docRef = doc(policiesCollection, policyDoc);
    const docSnap = await getDoc(docRef);

    if (!docSnap.exists()) return null

    return docSnap.data() as PolicyDocument
  } catch (error) {
    console.error("Error getting return policy:", error);
    return null
  }
};

export const getReturnPolicies = async (isDefault?: boolean): Promise<PolicyDocument[]> => {
  try {
    const constraints = [
      where("type", "==", "return-policy"),
      orderBy("created", "desc"),
    ];

    if (isDefault) constraints.push(where("default", "==", isDefault));

    const q = query(policiesCollection, ...constraints);
    const docSnap = await getDocs(q);

    if (docSnap.empty) return [];

    return docSnap.docs.map((doc) => doc.data() as PolicyDocument);
  } catch (error) {
    console.error("Error fetching return policies:", error);
    throw error;
  }
};
